import * as React from 'react';
import { useTheme } from '@mui/material/styles';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};


function getStyles(name, personName, theme) {
  return {
    fontWeight:
      personName.indexOf(name) === -1
        ? theme.typography.fontWeightRegular
        : theme.typography.fontWeightMedium,
  };
}

export  function EventSelector( props ) {
  const theme = useTheme();
  const {list} = props;
  const { events, setEvents} = props;
  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    setEvents(
      // On autofill we get a stringified value.
      typeof value === 'string' ? value.split(',') : value,
    );
  };

  return (
    <div>
      <FormControl sx={{ m: 1, width: '100%' }}>
        <InputLabel id="event-selector-label">Event filter</InputLabel>
        <Select
          labelId="event-selector-label"
          id="event-selector"
          multiple
          value={events}
          onChange={handleChange}
          input={<OutlinedInput label="Event filter" />}
          MenuProps={MenuProps}
          disabled={!(list?.length > 0)}
        >
          {list.map((l) => (
            <MenuItem
              key={l.id}
              value={l.id}
              style={getStyles(l, events, theme)}
            >
              {l.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
}